import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import TabListInformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabListInformationCard';
import TabWithCaption from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabWithCaption';

type TabContentColumn = {
  id: string;
  value: string;
  icon?: React.ReactElement;
};

type TabColumn = {
  id: string;
  value: TabContentColumn[];
};

type TabConfig = {
  id: string;
  label: string;
  content: TabColumn[];
};

type ConfiguredTabListInformationCardProps = InformationCardProps & {
  config: TabConfig[];
  hasDismissButton?: boolean;
  onDismiss?: () => void;
};

const ConfiguredTabListInformationCard: React.FC<ConfiguredTabListInformationCardProps> = (props) => {
  const { config, hasDismissButton, onDismiss, ...rest } = props;

  return (
    <TabListInformationCard hasDismissButton={hasDismissButton} onDismiss={onDismiss} {...rest}>
      {config.map((tab) => (
        <TabWithCaption key={tab.id} label={tab.label}>
          {tab.content.map((column) => (
            <div key={column.id}>
              {column.value.map((paragraph) => (
                <Typography2 component="p" key={paragraph.id} variant="bodyPrimary">
                  <FormattedHTMLMessage message={paragraph.value} icon={paragraph.icon || null} />
                </Typography2>
              ))}
            </div>
          ))}
        </TabWithCaption>
      ))}
    </TabListInformationCard>
  );
};

export default ConfiguredTabListInformationCard;
